// extracted by mini-css-extract-plugin
export default {"mytooltip":"tooltip_mytooltip__36sx8","tooltip-inner":"tooltip_tooltip-inner__m+XxN"};